import { z } from 'zod';

export const workspaceTypes = [
  'ledger',
  'payments',
  'free_tier_ledger',
] as const;
export const WorkspaceTypeSchema = z.enum(workspaceTypes);
export type WorkspaceType = (typeof workspaceTypes)[number];
